import { z } from 'zod';
import { SanityDocumentSchema, SanityDocumentLikeSchema } from '../sanity';
import { EntityType } from '../../types';

export const NavItemSchema = z
  .object({
    parent: z.string().nullish(),
    id: z.string(),
    itemType: z
      .enum(['folder', 'link'])
      .nullish()
      .transform((x) => x ?? 'link'),
    folder: z
      .object({
        name: z
          .string()
          .nullish()
          .transform((x) => x ?? '')
      })
      .nullish(),
    link: z
      .object({
        title: z
          .string()
          .nullish()
          .transform((x) => x ?? ''),
        destination: z.object({
          type: z
            .enum(['url', 'page'])
            .nullish()
            .transform((x) => x ?? 'url'),
          href: z.string().nullish(),
          page: SanityDocumentLikeSchema.partial().nullish()
        }),
        style: z
          .enum(['default', 'primary', 'secondary'])
          .nullish()
          .transform((x) => x ?? 'default')
      })
      .nullish()
  })
  .refine((value) => {
    if (value.itemType === 'folder' && !value.folder) {
      throw new Error('Folder items must have a folder object');
    }

    if (value.itemType === 'link' && !value.link) {
      throw new Error('Link items must have a link object');
    }

    if (!value.link && !value.folder) {
      throw new Error('NavItem must have either a folder or link object');
    }

    return true;
  });

export const NavigationSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.Navigation),
  name: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  primaryNavigation: z.object({
    navItems: z.array(NavItemSchema)
  })
});

export type Navigation = z.infer<typeof NavigationSchema>;
export type NavItem = z.infer<typeof NavItemSchema>;
